import { AnyAction } from "@reduxjs/toolkit";
import { OnboardingRulesProgressResponse } from "@ifgengineering/client-invest-sdk";
import { signInAsync, signOutAsync } from "../auth/auth.actions";
import { fetchDealAnchoredProgressAPI } from "./dealAnchoredProgress.actions";

export interface DealAnchoredProgressState {
  neverLoaded: boolean;
  loading: boolean;
  data: OnboardingRulesProgressResponse | null;
}

export const INITIAL_STATE: DealAnchoredProgressState = {
  neverLoaded: true,
  loading: false,
  data: null,
};

const dealAnchoredProgressReducer = (
  state = INITIAL_STATE,
  action: AnyAction
): DealAnchoredProgressState => {
  switch (action.type) {
    case signInAsync.fulfilled.type:
    case signOutAsync.fulfilled.type:
      return { ...INITIAL_STATE };
    case fetchDealAnchoredProgressAPI.pending.type:
      return { ...state, loading: true };
    case fetchDealAnchoredProgressAPI.fulfilled.type:
      return {
        ...state,
        loading: false,
        neverLoaded: false,
        data: action.payload,
      };
    default:
      return state;
  }
};

export default dealAnchoredProgressReducer;
